import type { Group, GroupResponse } from './types'
import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import type { ZodIssue } from 'zod'

import { isAxiosError } from 'axios'

import { ValidationError } from '../../pages/vendors/errors/validation-error'
import $api from '../index'

export const GroupApi = {
  async getGroups(
    params: Record<string, string | string[]>,
    config?: AxiosRequestConfig
  ): Promise<GroupResponse> {
    return $api
      .get<GroupResponse>('/groups', { params, ...config })
      .then((response: AxiosResponse) => {
        return response.data
      })
  },
  async updateGroup(id: string, body: Partial<Omit<Group, 'id'>>): Promise<void> {
    try {
      await $api.patch(`/groups/${id}`, body)
    } catch (error) {
      if (isAxiosError<{ issues: ZodIssue[] }>(error) && error.response?.status === 422) {
        throw new ValidationError(error.response.data.issues)
      }
      throw new Error('Failed to update group')
    }
  },
  async updateNetworkGroup(
    id: string,
    body: Pick<
      Group,
      | 'network'
      | 'network_originator_id'
      | 'network_banking_id'
      | 'network_account_number'
      | 'network_routing_number'
      | 'reports'
    >
  ): Promise<void> {
    try {
      await $api.patch(`/groups/network/${id}`, body)
    } catch (error) {
      if (isAxiosError<{ issues: ZodIssue[] }>(error) && error.response?.status === 422) {
        throw new ValidationError(error.response.data.issues)
      }
      throw new Error('Failed to update group')
    }
  }
}
